module.exports = __webpack_public_path__ + "static/media/1012989.453274ca.jpg";